import {Tabs} from "antd";
import React, {useEffect} from "react";
import CalculatedTable from "./calculatedTable/CalculatedTable";
import {useHistory} from "react-router-dom/cjs/react-router-dom.min";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "../../../hooks/useFetch";

const VALID_STATUSES = ["calculated"];

const CalculatedTransfer = () => {
    const stores = useStore();
    const history = useHistory();
    const queryParams = new URLSearchParams(history.location.search);
    const status = queryParams.get("status");
    const [transferReferenceDataLoading, transferReferenceData, _, __, refetch] = useFetch({
        fetchFn: () =>
            stores.transferStore.getTransferReference({
                id: queryParams.get("id"),
                status
            }),
        loading: true,
        initialCall: true
    });

    useEffect(() => {
        if (!status || !VALID_STATUSES.includes(status)) {
            history.push("/transfers");
            return;
        }
    }, [status]);

    return (
        <div>
            <CalculatedTable
                transferReferenceData={transferReferenceData?.transferReference}
                transferReferenceDataLoading={transferReferenceDataLoading}
            />
        </div>
    );
};

export default CalculatedTransfer;
